(function () {
  let debounceTimer;

  function parseMoneyCents(el) {
    let text = el ? el.textContent.trim() : '';
    text = text.replace(/[^0-9.,]/g, '');
    if (text.indexOf(',') !== -1 && text.indexOf('.') !== -1) {
      // both separators: comma is thousands, period is decimal
      text = text.replace(/,/g, '');
    } else if (text.indexOf(',') !== -1) {
      // comma is decimal separator (European format)
      text = text.replace(',', '.');
    }
    return Math.round(parseFloat(text) * 100) || 0;
  }

  function formatSavings(cents, currencySymbol) {
    let dollars = cents / 100;
    return (currencySymbol || '$') + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function extractCurrencySymbol(el) {
    if (!el) return '$';
    let match = el.textContent.match(/^[^0-9]+/);
    return match ? match[0].trim() : '$';
  }

  let observedRoots = new WeakSet();

  function queryShadowAll(root, selector) {
    let results = [];
    try {
      root.querySelectorAll(selector).forEach(function (el) { results.push(el); });
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) {
          observeShadowRoot(el.shadowRoot);
          queryShadowAll(el.shadowRoot, selector).forEach(function (r) { results.push(r); });
        }
      });
    } catch (e) {}
    return results;
  }

  function updateSavingsCallouts() {
    let containers = queryShadowAll(document.body, '.text-right.whitespace-nowrap');
    containers.forEach(function (container) {
      let originalEl = container.querySelector('[part="money"]:not([part~="discount"])');
      let discountEl = container.querySelector('[part~="discount"]');
      let savingEl = container.querySelector('.text-xs.text-right');

      if (!originalEl || !discountEl || !savingEl) return;

      let savedCents = parseMoneyCents(originalEl) - parseMoneyCents(discountEl);
      if (savedCents > 0) {
        let next = 'Saving ' + formatSavings(savedCents);
        if (savingEl.textContent !== next) savingEl.textContent = next;
      }
    });
  }

  function scheduleUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateSavingsCallouts, 200);
  }

  function observeShadowRoot(root) {
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    let obs = new MutationObserver(scheduleUpdate);
    obs.observe(root, { childList: true, subtree: true });
  }

  let observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.body, { childList: true, subtree: true });
})();
